import { render, staticRenderFns } from "./WidgetInformations.vue?vue&type=template&id=5831fd15&scoped=true&"
import script from "./WidgetInformations.vue?vue&type=script&lang=js&"
export * from "./WidgetInformations.vue?vue&type=script&lang=js&"
import style0 from "./WidgetInformations.vue?vue&type=style&index=0&id=5831fd15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5831fd15",
  null
  
)

export default component.exports